import React from 'react';
import styled from 'styled-components';

const ToggleButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 8px 16px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
  }
`;

const ThemeToggle: React.FC = () => {
  const toggleTheme = () => {
    const root = document.documentElement;
    const currentBg = getComputedStyle(root).getPropertyValue('--dark-bg');
    
    if (currentBg.includes('26, 26, 46')) {
      // Mudar para tema escuro total
      root.style.setProperty('--dark-bg', 'rgb(0, 0, 0)');
      root.style.setProperty('--card-bg', 'rgba(20, 20, 20, 0.8)');
    } else {
      // Voltar ao tema original
      root.style.setProperty('--dark-bg', 'rgb(26, 26, 46)');
      root.style.setProperty('--card-bg', 'rgba(255, 255, 255, 0.1)');
    }
  };

  return (
    <ToggleButton onClick={toggleTheme}>
      🎨 Tema
    </ToggleButton>
  );
};

export default ThemeToggle;